import {useState} from 'react';
import {Button, Input, InputNumber, Card, Row, message} from 'antd';
import {insertPayment} from "../../api/Api";
import {BankSelectWidget} from "../widget/BankSelectWidget";
import {DatePickerWidget} from "../widget/DatePickerWidget";

const {TextArea} = Input;

export const NewPayment = ({refresh, onRefresh, onApiFail, props}) => {
    const [amount, setAmount] = useState (undefined)
    const [bank, setBank] = useState(undefined);
    const [notes, setNotes] = useState(undefined);
    const [messageApi, contextHolder] = message.useMessage();

    const [date, setDate] = useState(undefined);
    // displayDate is important, we are working around a UTC to local timezone change
    // we need to feed DatePickerWidget a local time so that it works as expected, otherwise date is off by 1
    const [displayDate, setDisplayDate] = useState(undefined);

    const onAmountChange = (val) => {
        setAmount(val);
    }

    const onBankChange = (val) => {
        setBank(val);
    }

    const onDateChange = (dateString, dateJS) => {
        setDate(dateString);

        const dateJsString = dateJS.toString();

        // we will set displayDate to a local time for DatePickerWidget
        setDisplayDate(dateJsString);
    }

    const onNotesChange = (e) => {
        setNotes(e.target.value);
    }

    const clearForm = () => {
        setAmount(undefined);
        setBank(undefined);
        setNotes(undefined);
    }

    const onConfirm = () => {
        insertPayment(amount, bank, date, notes).then(r => {
            clearForm();
            if (onRefresh) onRefresh();
            messageApi.open({
                type: "success",
                content: "Payment added successfully"
            });
        }).catch (e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
            messageApi.open({
                type: "error",
                content: "Failed to add payment"
            })
        });
    }

    const amountUndefined = amount === undefined || amount === null;
    const bankUndefined = bank === undefined || bank === null;
    const notesUndefined = notes === undefined  || notes === null || notes === "";
    const saveDisabled = amountUndefined || bankUndefined || notesUndefined;

    let errorMessage = "";
    if (amountUndefined) errorMessage += "Set an amount.  "
    if (bankUndefined) errorMessage += "Set an account.  "
    if (notesUndefined) errorMessage += "Include notes.  "

    const rowStyle= {margin: '5px'}

    return <div style={{textAlign: 'left', width: '800px'}}>
        {contextHolder}
        <Card title={`Enter New Payment`} orientation={'left'}>
            <Row style={rowStyle}>
                <InputNumber min={0} precision={2} value={amount} placeholder={'amount'} addonBefore={'$'} onChange={onAmountChange} />
            </Row>
            <Row style={rowStyle}>
                <BankSelectWidget accountId={bank} setAccountId={onBankChange} onApiFail={onApiFail} />
            </Row>
            <Row style={rowStyle}>
                <DatePickerWidget placeholder={"Back Date"} onChange={onDateChange} date={displayDate} />
            </Row>
            <Row style={rowStyle}>
                <TextArea value={notes} onChange={onNotesChange} placeholder={'Notes'} maxLength={2048} rows={4} showCount />
            </Row>
            <Row style={rowStyle}>
                <Button disabled={saveDisabled} onClick={onConfirm}>Save</Button>
            </Row>
            <Row style={{rowStyle}}>
                {(errorMessage.length > 0) && <div style={{color: 'red'}}>{errorMessage}</div>}
            </Row>
        </Card>
    </div>
}